import React, { useState } from 'react';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Button } from '../components/ui/Button';
interface ContactProps {
  navigate: (page: string) => void;
}
export function Contact({
  navigate
}: ContactProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Simple client-side validation (replaces zod contactSchema)
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) newErrors.name = 'Numele este obligatoriu';
    if (!formData.email.trim()) newErrors.email = 'Email-ul este obligatoriu';
    if (!formData.message.trim()) newErrors.message = 'Mesajul este obligatoriu';
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setIsSubmitting(true);
    setSubmitError('');
    setErrors({});
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <div className="min-h-screen bg-dark-1" data-id="element-3215">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-3216">
        <div className="text-center mb-12" data-id="element-3217">
          <h1 className="text-3xl sm:text-4xl font-bold text-light-1" data-id="element-3218">
            Contact
          </h1>
          <p className="text-light-3 mt-3 max-w-md mx-auto" data-id="element-3219">
            Ai o intrebare sau o sugestie? Trimite-ne un mesaj si iti vom
            raspunde cat mai curand.
          </p>
        </div>

        {isSuccess ? <div className="p-8 text-center rounded-2xl bg-lime-5 border border-lime-4" data-id="element-3220">
            <div className="w-16 h-16 rounded-full bg-lime-4 flex items-center justify-center mx-auto mb-4" data-id="element-3221">
              <svg className="w-8 h-8 text-lime-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3222">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-3223" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-light-1" data-id="element-3224">
              Mesaj trimis cu succes!
            </h3>
            <p className="text-sm text-light-2 mt-2" data-id="element-3225">
              Iti multumim! Te vom contacta in curand.
            </p>
          </div> : <form onSubmit={handleSubmit} className="space-y-5 p-6 sm:p-8 rounded-2xl border border-dark-4 bg-dark-2/50" data-id="element-3226">
            <div className="space-y-1.5" data-id="element-3227">
              <label className="block text-sm font-medium text-foreground" data-id="element-3228">
                Numele tau
              </label>
              <Input value={formData.name} onChange={e => setFormData(p => ({
            ...p,
            name: e.target.value
          }))} placeholder="ex: Ion Popescu" aria-invalid={!!errors.name} data-id="element-3229" />
              {errors.name && <p className="text-xs text-destructive" data-id="element-3230">{errors.name}</p>}
            </div>

            <div className="space-y-1.5" data-id="element-3231">
              <label className="block text-sm font-medium text-foreground" data-id="element-3232">
                Email
              </label>
              <Input type="email" value={formData.email} onChange={e => setFormData(p => ({
            ...p,
            email: e.target.value
          }))} placeholder="email@exemplu.ro" aria-invalid={!!errors.email} data-id="element-3233" />
              {errors.email && <p className="text-xs text-destructive" data-id="element-3234">{errors.email}</p>}
            </div>

            <Textarea label="Mesaj" value={formData.message} onChange={e => setFormData(p => ({
          ...p,
          message: e.target.value
        }))} placeholder="Scrie mesajul tau aici..." rows={5} error={errors.message} data-id="element-3235" />

            {submitError && <div className="p-3 rounded-lg bg-destructive/10 text-destructive text-sm" data-id="element-3236">
                {submitError}
              </div>}

            <Button type="submit" disabled={isSubmitting} className="w-full" size="lg" data-id="element-3237">
              {isSubmitting ? <span className="flex items-center gap-2" data-id="element-3238">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-3239" />
                  Se trimite...
                </span> : 'Trimite mesajul'}
            </Button>
          </form>}
      </div>
    </div>;
}